import { memo } from 'react';
import { useParams } from 'react-router-dom';
import { EquipmentItem as AdminEquipmentItem } from '@/admin-pages/Equipments/Item/EquipmentItem';

export default memo(function OrganizationEquipmentItem() {
  const { orgId } = useParams<{ orgId: string }>();
  return (
    <AdminEquipmentItem orgId={Number(orgId)} />
  );
});
